"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const idm_locale_service_client_js_1 = require("@synisys/idm-locale-service-client-js");
const Observable_1 = require("rxjs/Observable");
let DateTimeFormatPipe = class DateTimeFormatPipe {
    constructor(localeService) {
        this.localeService = localeService;
        this.format = {
            date: "date",
            dateTime: "dateTime",
            time: "time"
        };
    }
    transform(date, format = this.format.dateTime, languageId) {
        const localInfo$ = Observable_1.Observable.from(this.localeService.getLocaleInfo(languageId));
        if (date == null) {
            return null;
        }
        const timestamp = (typeof date !== "number" && typeof date !== "string") ? date.getTime() : +date;
        switch (format) {
            case this.format.date:
                return localInfo$.map((info) => this.localeService.formatDateByLocale(timestamp, info));
            case this.format.dateTime:
                return localInfo$.map((info) => this.localeService.formatDateTimeByLocale(timestamp, info));
            case this.format.time:
                return localInfo$.map((info) => this.localeService.formatTimeByLocale(timestamp, info));
        }
    }
};
DateTimeFormatPipe = __decorate([
    core_1.Pipe({
        name: "sisDateTimeFormat"
    }),
    __metadata("design:paramtypes", [idm_locale_service_client_js_1.LocaleService])
], DateTimeFormatPipe);
exports.DateTimeFormatPipe = DateTimeFormatPipe;
//# sourceMappingURL=date-format.pipe.js.map